import { render, staticRenderFns } from "./override-arrears.vue?vue&type=template&id=be40b466&scoped=true"
import script from "./override-arrears.vue?vue&type=script&lang=js"
export * from "./override-arrears.vue?vue&type=script&lang=js"
import style0 from "./override-arrears.vue?vue&type=style&index=0&id=be40b466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be40b466",
  null
  
)

export default component.exports